import { render, staticRenderFns } from "./unPacking.vue?vue&type=template&id=61e2946a&scoped=true"
import script from "./unPacking.vue?vue&type=script&lang=js"
export * from "./unPacking.vue?vue&type=script&lang=js"
import style0 from "./unPacking.vue?vue&type=style&index=0&id=61e2946a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e2946a",
  null
  
)

export default component.exports